<template>
  <div class="business-guide" v-loading="!baseInfo">
    <div class="business-guide-title">办事指南</div>
    <el-tabs v-if="!isMobileMode" v-model="currentMode" type="border-card" class="mode-tab" stretch>
      <el-tab-pane label="基本信息" name="basic">
        <table class="info basic">
          <tr>
            <td>事项名称:</td>
            <td colspan="3">{{baseInfo.NAME}}</td>
          </tr>
          <tr>
            <td>事项编码:</td>
            <td>{{baseInfo.CODE}}</td>
            <td>事项类型:</td>
            <td>{{typeMap[baseInfo.TYPE] || '其他'}}</td>
          </tr>
          <tr>
            <td>办件类型:</td>
            <td>{{assortMap[baseInfo.ASSORT] || ''}}</td>
            <td>信用承诺:</td>
            <td>{{baseInfo.IS_PROMISE == '1' ? '是' : '否'}}</td>
          </tr>
          <tr>
            <td>法定办理期限:</td>
            <td>{{baseInfo.LAW_TIME + dateMap[baseInfo.LAW_TIME_UNIT]}}</td>
            <td>承诺办理期限:</td>
            <td>{{baseInfo.AGREE_TIME + dateMap[baseInfo.AGREE_TIME_UNIT]}}</td>
          </tr>
          <tr>
            <td>受理机构:</td>
            <td>{{baseInfo.NAME}}</td>
            <td>承诺期限说明:</td>
            <td>{{baseInfo.AGREE_TIME_BASIS || '无'}}</td>
          </tr>
          <tr>
            <td>申报对象:</td>
            <td>{{baseInfo.SERVICE_OBJECT == '1' ? '自然人' : '法人'}}</td>
            <td>审查方式:</td>
            <td>{{baseInfo.PROCEDURE_NAME || '无'}}</td>
          </tr>
          <tr>
            <td>特殊环节时限:</td>
            <td>{{(baseInfo.PROCEDURE_TIME == null || baseInfo.PROCEDURE_TIME == 'null') ? '无' : `${baseInfo.PROCEDURE_TIME}工作日`}}</td>
            <td>特殊环节时限说明:</td>
            <td>{{baseInfo.PROCEDURE_TIME_BASIS || '无'}}</td>
          </tr>
          <tr>
            <td>是否收费:</td>
            <td>{{baseInfo.IS_CHARGE == '0' ? '否' : '是'}}</td>
            <td>是否网上支付:</td>
            <td>{{baseInfo.PAY_ONLINE == '0' ? '否' : '是'}}</td>
          </tr>
          <tr>
            <td>办理结果:</td>
            <td>{{resultSelect(baseInfo.FINISH_TYPE)}}</td>
            <td>结果获取方式:</td>
            <td>{{baseInfo["FINISH_GET_TYPE"] == null ? "现场取件" : baseInfo["FINISH_GET_TYPE"]}}</td>
          </tr>
          <tr>
            <td>结果获取说明:</td>
            <td colspan="3">{{baseInfo.FINISH_INFO  || '无'}}</td>
          </tr>
          <tr>
            <td>申请条件:</td>
            <td v-html="conditionContent(conditions)" colspan="3"></td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="申报材料" name="material">
        <table class="info material">
          <tr>
            <td>序号</td>
            <td>材料名称</td>
            <td>材料类型</td>
            <td>是否电子材料</td>
            <td>容缺</td>
            <td>原件</td>
            <td>复印件</td>
            <td>材料下载</td>
            <td>填报须知</td>
            <td>受理标准</td>
          </tr>
          <tr v-for="(m, i) in materials">
            <td>{{i + 1}}</td>
            <td>{{m.NAME}}</td>
            <td>{{mTypeMap[m.TYPE] || ''}}</td>
            <td>{{m.MUST == '0' ? '否' : '是'}}</td>
            <td>{{m.IS_LACK == '0' ? '否' : '是'}}</td>
            <td>{{m.ORIGIN == '0' ? '否' : '是'}}</td>
            <td>{{m.COPY == '0' ? '否' : '是'}}</td>
            <td>
              <span v-html="ifSampleNull(m)"></span><br>
              <span v-html="ifEmptyNull(m)"></span>
            </td>
            <td>{{m.WHEREVER || ''}}</td>
            <td>{{m.HOW || ''}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="法律依据" name="law">
        <table class="info">
          <tr>
            <td>序号</td>
            <td>法律法规名称</td>
            <td>条款名称</td>
            <td>条款内容</td>
          </tr>
          <tr v-for="(l, i) in laws">
            <td>{{(i + 1)}}</td>
            <td>{{l.CONTENT}}</td>
            <td>{{l.TERM_NAME}}</td>
            <td>{{l.NAME}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="办理流程" name="steps">
        <table class="info steps">
          <tr>
            <td>序号</td>
            <td>所属环节</td>
            <td>步骤名称</td>
            <td>特殊环节名称</td>
            <td>办理时限</td>
            <td>审查标准</td>
            <td>办理结果</td>
            <td>审查方式</td>
            <td>环节说明</td>
          </tr>
          <tr v-for="(s, i) in steps">
            <td>{{(i + 1)}}</td>
            <td>{{s.LINK_NAME}}</td>
            <td>{{s.STEP_NAME}}</td>
            <td>{{s.SPECIAL_LINK_NAME}}</td>
            <td>{{(s.LIMIT_COUNT == '0' ? '当场' : s.LIMIT_COUNT) + (s.LIMIT_COUNT == '0' ? '' : dateMap[s.LIMIT_COUNT_UNIT])}}</td>
            <td>{{s.REVIEW_STANDARD}}</td>
            <td>{{s.TRANSACT_RESULT}}</td>
            <td>{{s.PROCESS_PROCEDURE_NAME}}</td>
            <td>{{s.NODE_DESCRIPTION}}</td>
          </tr>
        </table>
      </el-tab-pane>
    </el-tabs>

    <van-collapse v-if="isMobileMode" v-model="currentModeList">
      <van-collapse-item title="基本信息" name="basic">
        <van-cell-group>
          <van-cell title="事项名称" :value="baseInfo.NAME" />
          <van-cell title="事项编码" :value="baseInfo.CODE" />
          <van-cell title="事项类型" :value="typeMap[baseInfo.TYPE] || '其他'" />
          <van-cell title="办件类型" :value="assortMap[baseInfo.ASSORT] || ''" />
          <van-cell title="信用承诺" :value="baseInfo.IS_PROMISE == '1' ? '是' : '否'" />
          <van-cell title="法定办理期限" :value="baseInfo.LAW_TIME + dateMap[baseInfo.LAW_TIME_UNIT]" />
          <van-cell title="承诺办理期限" :value="baseInfo.AGREE_TIME + dateMap[baseInfo.AGREE_TIME_UNIT]" />
          <van-cell title="受理机构" :value="baseInfo.NAME" />
          <van-cell title="承诺期限说明" :value="baseInfo.AGREE_TIME_BASIS || '无'" />
          <van-cell title="申报对象" :value="baseInfo.SERVICE_OBJECT == '1' ? '自然人' : '法人'" />
          <van-cell title="审查方式" :value="baseInfo.PROCEDURE_NAME || '无'" />
          <van-cell title="特殊环节时限" :value="(baseInfo.PROCEDURE_TIME == null || baseInfo.PROCEDURE_TIME == 'null') ? '无' : `${baseInfo.PROCEDURE_TIME}工作日`" />
          <van-cell title="特殊环节时限说明" :value="baseInfo.PROCEDURE_TIME_BASIS || '无'" />
          <van-cell title="是否收费" :value="baseInfo.IS_CHARGE == '0' ? '否' : '是'" />
          <van-cell title="是否网上支付" :value="baseInfo.PAY_ONLINE == '0' ? '否' : '是'" />
          <van-cell title="办理结果" :value="resultSelect(baseInfo.FINISH_TYPE)" />
          <van-cell title="结果获取方式" :value="baseInfo['FINISH_GET_TYPE'] == null ? '现场取件' : baseInfo['FINISH_GET_TYPE']" />
          <van-cell title="结果获取说明" :value="baseInfo.FINISH_INFO  || '无'" />
          <van-cell title="申请条件">
             <template #value>
                <div v-html="conditionContent(conditions)"></div>
              </template>
          </van-cell>
        </van-cell-group>
      </van-collapse-item>
      <van-collapse-item title="申报材料" name="material">
        <template v-for="(u, i) in materials">
          <van-cell-group :key="u.NAME" :title="(i + 1) + '. ' + u.NAME">
            <van-cell title="材料名称" :value="u.NAME" />
            <van-cell title="材料类型" :value="mTypeMap[u.TYPE] || ''" />
            <van-cell title="是否电子材料" :value="u.MUST == '0' ? '否' : '是'" />
            <van-cell title="容缺" :value="u.IS_LACK == '0' ? '否' : '是'" />
            <van-cell title="原件" :value="u.ORIGIN == '0' ? '否' : '是'" />
            <van-cell title="复印件" :value="u.COPY == '0' ? '否' : '是'" />
            <!-- <van-cell title="材料下载" :value="u.CODE">
             <template #value>
              <div>
                <span v-html="ifSampleNull(u)"></span><br>
                <span v-html="ifEmptyNull(u)"></span>
              </div>
             </template>
            </van-cell> -->
            <van-cell title="填报须知" :value="u.WHEREVER || ''" />
            <van-cell title="受理标准" :value="u.HOW || ''" />
          </van-cell-group>
        </template>
      </van-collapse-item>
      <van-collapse-item title="法律依据" name="law">
        <template v-for="(l, i) in laws">
          <van-cell-group :key="l.CONTENT" :title="(i + 1) + '. ' + l.CONTENT">
            <van-cell title="法律法规名称" :value="l.CONTENT" />
            <van-cell title="条款名称" :value="l.TERM_NAME" />
            <van-cell title="条款内容" :value="l.NAME" />
          </van-cell-group>
        </template>
      </van-collapse-item>
      <van-collapse-item title="办理流程" name="steps">
        <template v-for="(s, i) in steps">
          <van-cell-group :key="s.LINK_NAME" :title="(i + 1) + '. ' + s.LINK_NAME">
            <van-cell title="所属环节" :value="s.LINK_NAME" />
            <van-cell title="步骤名称" :value="s.STEP_NAME" />
            <van-cell title="特殊环节名称" :value="s.SPECIAL_LINK_NAME" />
            <van-cell title="办理时限" :value="(s.LIMIT_COUNT == '0' ? '当场' : s.LIMIT_COUNT) + (s.LIMIT_COUNT == '0' ? '' : dateMap[s.LIMIT_COUNT_UNIT])" />
            <van-cell title="审查标准" :value="s.REVIEW_STANDARD" />
            <van-cell title="办理结果" :value="s.TRANSACT_RESULT" />
            <van-cell title="审查方式" :value="s.PROCESS_PROCEDURE_NAME" />
            <van-cell title="环节说明" :value="s.NODE_DESCRIPTION" />
          </van-cell-group>
        </template>
      </van-collapse-item>
    </van-collapse>
    <br>
  </div>
</template>

<script>
import {Collapse, CollapseItem, CellGroup, Cell} from 'vant'
export default {
  components: {
    'van-collapse': Collapse,
    'van-collapse-item': CollapseItem,
    'van-cell-group': CellGroup,
    'van-cell': Cell,
  },
  props: {
    itemData: {
      type: Object,
      default() {
        return {}
      }
    },
    isMobileMode: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  watch:{
    itemData (newVal) {
      if (newVal) {
        this.currentMode = 'basic'
      }
    }
  },
  computed: {
    baseInfo () {
      let {
        ItemInfo,
      } = this.itemData
      return ItemInfo && ItemInfo[0] ? ItemInfo[0] : {}
    },
    materials () {
      return this.itemData.material || []
    },
    laws () {
      return this.itemData.legalbasis || []
    },
    steps () {
      return this.itemData.flow || []
    },
    conditions () {
      return this.itemData.condition || []
    },
  },
  data() {
    return {
      currentMode: 'basic',
      currentModeList: ['basic'],
      typeMap: {
        GCJSLB: "工程建设联办",
        BA: "残疾人基本服务",
        BM: "非通用事项",
        BMFW: "便民服务",
        BZ: "基本社会保障",
        CF: "行政处罚",
        CJ: "行政裁决",
        FG: "政策法规",
        FP: "基本住房保障",
        FW: "公共服务",
        JD: "行政监督检查",
        JF: "行政给付",
        JL: "行政奖励",
        LD: "基本劳动就业创业",
        PX: "基本公共文化体育",
        QL: "行政权力",
        QR: "行政确认",
        QT: "其他行政权力",
        QZ: "行政强制",
        SX: "其他权限事项",
        WH: "基本医疗卫生",
        XK: "行政许可",
        XT: "指导协调",
        ZM: "基本社会服务",
        ZS: "行政征收",
        ZX: "基本公共教育",
        ZY: "行政征用",
        ZZ: "其他权责事项",
        GG: "其他公共服务",
        FTYGG: "非通用其他公共服务",
        //非行政许可
      },
      assortMap: {
        "1": "承诺件",
        "2": "即办件",
        "3": "上报件",
        "4": "联办件"
      },
      dateMap: {
        "workday": "工作日",
        "normalday": "自然日",
        "year": "年",
        "month": "月",
        "hour": "小时",
        "now": ""
      },
      resultMap: {
        "0":"批文",
        "1":"证照",
        "2":"证明",
        "3":"其他"
      },
      mTypeMap: {
        "0":'申请表',
        "1":'证明材料',
        "3":'证照批文',
        "4":'其他',
      }
    }
  },
  methods: {
    resultSelect(z){
      if(z == null) {
        return "无";
      } else if (z.length == 1){
        switch(z){
          case "0":
            return "批文";
            break;
          case "1":
            return "证照";
            break;
          case "2":
            return "证明";
            break;
          case "3":
            return "其他";
            break;
          default:
            return "无";
            break;
        }
      } else {
        let str = z.split(',');
        let resultList = "";
        for(let i=0;i<str.length;i++){
          if(str[i] === "0"){
            resultList += "、批文";
          }else if(str[i] === "1"){
            resultList += "、证照";
          }else if(str[i] === "2"){
            resultList += "、证明";
          }else if(str[i] === "3"){
            resultList += "、其他";
          }else if(str[i] === "4"){
            resultList += "、无";
          }else{
            resultList += "  ";
          }
        }
        resultList = resultList.substring(1)
        return resultList;
      }
    },
    getResultSelect(x){
      let str1 = x.split(',');
      let resultList = "";
      if(str1 == null){
        return "无";
      }else{
        for(let i = 0; i < str1.length; i++){
          if(str1[i] === "A"){
            resultList += "、申请对象窗口领取";
          }else if(str1[i] === "B"){
            resultList += "、邮递办理结果";
          }else if(str1[i] === "C"){
            resultList += "、电子证照窗口拷取";
          }else if(str1[i] === "D"){
            resultList += "、电子证照送达政务通";
          }else if(str1[i] === "E"){
            resultList += "、其他";
          }else if(str1[i] === "F"){
            resultList += "、无 ";
          }
        }
        resultList = resultList.substring(1)
        return resultList;
      }
    },
    conditionContent(list) {
      var content = "";
      for(var n=0;n<list.length;n++){
        // content += ((n+1)+"."+list[n]["REMARK"]+"&nbsp;");
        content += ((n+1)+".&nbsp;");
        content += list[n]["NAME"];
        if(n == list.length -1){
          content += "";
        }else{
          content += "<br><br>";
        }
      }
      return content
    },
    ifSampleNull(x){
      if(x["SAMPLE_NAME"] == null){
        return "-";
      }else{
        return '<a href="http://120.40.102.230:9100/fwapi/c/api.transfer/downloadFile?doc_id='+x["SAMPLE"]+'&fileName='+x["SAMPLE_NAME"]+'&access_token=28C2829B204B4A09871C7DFD62447040" class="sel_btn" id="links" download>'+x["SAMPLE_NAME"]+'</a>';
      }
    },
    ifEmptyNull(y){
      if(y["EMPTY_NAME"] == null){
        return "-";
      }else{
        return '<a href="http://120.40.102.230:9100/fwapi/c/api.transfer/downloadFile?doc_id='+y["EMPTY"]+'&fileName='+y["EMPTY_NAME"]+'&access_token=28C2829B204B4A09871C7DFD62447040" class="sel_btn" id="links" download>'+y["EMPTY_NAME"]+'</a>';
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@style/_var.scss";
@import "~@style/_theme.scss";

.business-guide {
  .business-guide-title {
    margin: 20px 0 20px;
    font-size: 18px;
    text-align: center;
  }

  table {
    &.info {
      width: 100%;
      border-collapse: collapse;
      tr {
        &:nth-child(1) {
          text-align: center;
        }
        td {
          border: 1px solid #e4e4e4;
          padding: 8px 14px;

          &:nth-child(1) {
            min-width: 58px;
            text-align: center;
          }
        }
      }
    }

    &.basic {
      tr {
        &:nth-child(1) {
          text-align: left;
        }
        td {
          &:nth-child(2n+1) {
            text-align: right;
          }
        }
      }
    }

    &.material {
      tr {
        td {
          text-align: center;
          &:nth-child(n+2) {
            min-width: 48px;
          }
          &:nth-child(2) {
            max-width: 200px;
          }
          &:nth-child(8) {
            min-width: 220px;
          }
          &:nth-child(9) {
            width: 25%;
          }
        }
      }
    }

    &.steps {
      tr {
        td {
          min-width: 58px;

          &:nth-child(5) {
            min-width: 80px;
          }

          &:nth-child(6) {
            width: 280px;
          }

          &:nth-child(7) {
            width: 240px;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .business-guide {
    table {
      &.steps {
        tr {
          td {
            &:nth-child(6) {
              width: 400px;
            }
          }
        }
      }
    }
  }
}
</style>